import * as React from 'react';
import { FC } from 'react';

import { Card, Image, Label } from './loyalty-tier-card.styled';
import { ILoyaltyTierCardProps } from './types';

const LoyaltyTierCards: FC<ILoyaltyTierCardProps> = ({ handleTierClick, idx, tier }) => {
  const { id, image, inactive, label } = tier;

  return (
    <Card
      data-testid={`${label}-tier`}
      key={id}
      $inactive={inactive}
      onClick={() => handleTierClick(tier)}
    >
      <Image image={image} alt={`-image`} $idx={idx} />
      <Label>{label}</Label>
    </Card>
  );
};
export default LoyaltyTierCards;
